'use client'
import type { FieldValues, UseFormRegister } from 'react-hook-form'
import React, { useEffect } from 'react'
import { Input } from '@/ui/atoms/Input'
import { FormLabel } from '@/ui/atoms/FormLabel'

export const Honeypot: React.FC<{
  name: string
  register: UseFormRegister<FieldValues>
  setHoneyPotName: React.Dispatch<React.SetStateAction<string>>
}> = ({ name, register, setHoneyPotName }) => {
  useEffect(() => {
    setHoneyPotName(name)
  }, [name, setHoneyPotName])

  return (
    <React.Fragment>
      <FormLabel htmlFor={name} className="hidden">
        {name}
      </FormLabel>
      <Input id={name} className="hidden" type="text" {...register(name)} />
    </React.Fragment>
  )
}
